import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {MotrackingResponse, Response, TrackingModel} from '../models/models';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  private readonly apiUrl = environment.apiPath + 'tracking/';
  private readonly motrackingApiUrl = environment.motrackingUrl;
  private readonly motrackingKey = environment.motrackingKey;

  constructor(private readonly http: HttpClient) { }

  getTruckCoordinates(truckNumber: string): Observable<MotrackingResponse> {
    let params = new HttpParams();
    params = params.append('key', this.motrackingKey);
    params = params.append('car_number', truckNumber);

    return this.http.get<any>(this.motrackingApiUrl, {params}).pipe(
      map(response => {
        const motracking: MotrackingResponse = {
          Lat: response.data.units[0].lat,
          Lng: response.data.units[0].lng
        };
        return motracking;
      })
    );
  }

  getTransportDetails(orderNumber: number): Observable<Response<TrackingModel>> {
    return this.http.get<Response<TrackingModel>>(this.apiUrl + orderNumber);
  }

  checkDeliveryStatus(orderNumber: number): Observable<Response<boolean>>{
    return this.http.get<Response<boolean>>(this.apiUrl + 'CheckTransportStatus/' + orderNumber);
  }
}
